import React, { useContext, useEffect, useState } from "react";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { InputType, validationRegex } from "../../Utils/Utils";
import CustomTextEditor from "../../Components/Reusable/CustomTextEditor";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import { toast } from "react-toastify";
import DynamicService from "../../Services/DynamicService";
import { AuthContext } from "../../Context/authContext";

const PrivacyPolicy = () => {
  const [privacyPolicyData, setPrivacy] = useState();
  const [resetValue, setResetValue] = useState(false);
  const {user}=useContext(AuthContext)

  const Validations = yup.object().shape({
    title: validationRegex.required,
    details: validationRegex.required,
  });

  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    formState: { errors: errors },
    getValues: getValues,
    reset: reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      title: privacyPolicyData?.title || "",
      details: privacyPolicyData?.details || "",
    },
  });

  const fetchData = async () => {
    try {
      const response = await DynamicService.getPrivacyPolicy();
      setValues("title", response?.data?.title ?? "");
      setValues("details", response?.data?.title ?? "");
      setPrivacy(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  const onSubmit = async (privacyPolicyData) => {

    const dynamicPrivilege = user?.setPrivileges?.find(
      (priv) => priv.parameter === "Dynamic"
    );

    if (dynamicPrivilege?.update) {
    try {
      const response = await DynamicService.addPrivacyPolicy(
        privacyPolicyData.title,
        privacyPolicyData.details
      );
      toast.success(response.message);
    } catch (error) {
      handleApiErrors(error);
    }
  }else{
    toast.warning("You don't have permission to update privacy policy.");
  }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">PRIVACY POLICY</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0"> privacy policy</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">Privacy Policy</h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-4">
              <div className="">
                <CustomTextField
                  labelTitle="Title"
                  placeholder="File Name"
                  name="title"
                  id="title"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  setValue={setValues}
                  showError={errors?.title}
                  errorMessage={errors?.title?.message}
                />
              </div>
              <div>
                <CustomTextEditor
                  labelTitle={"Details"}
                  name="details"
                  id="details"
                  resetValue={resetValue}
                  setValue={setValues}
                  setResetValue={setResetValue}
                  showError={errors}
                  errorMessage={errors?.details?.message}
                  showMandatory={true}
                  defaultValue={privacyPolicyData?.details ?? ""}
                />
              </div>
              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={"Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
